import React from 'react';
import { buildQuoteProducts, quoteProductSummary } from '../utils/quoteProducts';
import './QuoteProductsTable.css';

export default function QuoteProductsSummary({ quote, showHeading = true }) {
  const products = Array.isArray(quote?.products)
    ? quote.products
    : quote?.product_code ? buildQuoteProducts(quote) : [];
  const summary = quoteProductSummary(products);
  const money = value => value != null && value !== '' ? '₹ ' + Number(value).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '—';
  return (
    <section className="quote-products quote-products--readonly" aria-label="Quote product details">
      {showHeading && <div className="quote-products__heading"><h5>Products</h5></div>}
      <div className="quote-products__scroll">
        <table className="quote-products__table" aria-label="Saved quote products">
          <thead><tr>
            <th scope="col">Product Code</th>
            <th scope="col" className="quote-products__qty">Quantity</th>
            <th scope="col" className="quote-products__money">Unit Price</th>
            <th scope="col" className="quote-products__money">Total</th>
          </tr></thead>
          <tbody>{products.map((row, index) => <tr key={row.id ?? row._key ?? index}>
            <td>{row.product_code || '—'}</td>
            <td className="quote-products__qty">{row.qty ?? '—'}</td>
            <td className="quote-products__money">{money(row.unit_price)}</td>
            <td className="quote-products__money">{money(row.total)}</td>
          </tr>)}
            {!products.length && <tr><td colSpan={4} className="quote-products__empty">No products found</td></tr>}
          </tbody>
          <tfoot>
            <tr>
              <th scope="row">Grand Total</th>
              <td className="quote-products__qty">{products.length ? summary.qty : '—'}</td>
              <td className="quote-products__money" aria-hidden="true" />
              <td className="quote-products__money">{money(summary.total)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </section>
  );
}
